import { uniqBy, path } from 'ramda'

// Cache policies
const replaceArray = {
  merge(existing, incoming) {
    return [...incoming]
  }
}

const arrayReplacePolicy = (type, fieldsList) => {
  const fields = {}
  const policies = fieldsList.map(i => ({ [i]: replaceArray }))
  Object.assign(fields, ...policies)

  return {
    [type]: { fields }
  }
}

export const typePolicies = {
  ...arrayReplacePolicy('ClaimV2', ['medical_bills']),
  ...arrayReplacePolicy('Tickets', ['chats', 'deliverables', 'tasks']),
  ...arrayReplacePolicy('DoctorProfileV2', ['specialties', 'addresses']),
  Query: {
    fields: {
      tickets: {
        merge(_, incoming) {
          return incoming
        }
      }
    }
  },
  TicketAlarm: {
    keyFields: ['datetime', 'notes']
  },
  PrescriptionModel: {
    keyFields: ['id', 'date']
  },
  Chat: {
    fields: {
      messages: {
        // Concatenate the incoming list items with
        // the existing list items.
        merge(existing = { nodes: [] }, incoming) {
          const nodes = uniqBy(path(['__ref']), [
            ...incoming.nodes,
            ...existing.nodes
          ])

          // Crutch for the retarded apollo logic with duplicating queries
          const isDuplicateRequest = nodes.length === existing.nodes.length

          // Sorting crutch
          nodes.sort((a, b) =>
            a.__ref.localeCompare(b.__ref, undefined, {
              numeric: true,
              sensitivity: 'base'
            })
          )

          const result = {
            ...incoming,
            nodes,
            // replace wrong pageInfo from a duplicate, careful here
            ...(isDuplicateRequest &&
              existing?.pageInfo && { pageInfo: existing.pageInfo })
          }

          return result
        },

        read(existing = { nodes: [] }) {
          const { nodes } = existing

          return {
            ...existing,
            nodes
          }
        }
      }
    }
  }
}
